import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../../shared/data.service";
import { JobScheduleInsertRequest } from "../../shared/job-schedule-insert-request";
import * as moment from "moment";
import { JobScheduleUpdateRequest } from "../../shared/job-schedule-update-request";

@Component({
	selector: "app-ri-schedule-modify",
	templateUrl: "./ri-schedule-modify.component.html",
	styleUrls: ["./ri-schedule-modify.component.css"],
})
export class RiScheduleModifyComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService,
		private dataService: DataService_ScheduledJobs
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.JobID = this.dialogConfig.data.JobID;
		this.JobDesc = this.dialogConfig.data.JobDesc;
		this.JobScheduleID = this.dialogConfig.data.JobScheduleID;
		this.Active = this.dialogConfig.data.Active;
		this.RunTime = this.dialogConfig.data.RunTime;
		this.RunMon = this.dialogConfig.data.RunMon;
		this.RunTue = this.dialogConfig.data.RunTue;
		this.RunWed = this.dialogConfig.data.RunWed;
		this.RunThu = this.dialogConfig.data.RunThu;
		this.RunFri = this.dialogConfig.data.RunFri;
		this.RunSat = this.dialogConfig.data.RunSat;
		this.RunSun = this.dialogConfig.data.RunSun;
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	EditMode: boolean = false;
	JobID: number = -1;
	JobDesc: string = "";
	JobScheduleID: number = -1;

	Active: boolean = false;
	RunTime: Date = new Date();
	RunMon: boolean = true;
	RunTue: boolean = true;
	RunWed: boolean = true;
	RunThu: boolean = true;
	RunFri: boolean = true;
	RunSat: boolean = false;
	RunSun: boolean = false;

	Processing: boolean = false;
	errorMessage: string = "";

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		var fDate = moment(this.RunTime).format("HH:mm:00");

		if (String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Run Time";
			return;
		}

		if (
			this.RunMon == false &&
			this.RunTue == false &&
			this.RunWed == false &&
			this.RunThu == false &&
			this.RunFri == false &&
			this.RunSat == false &&
			this.RunSun == false
		) {
			this.errorMessage = "Select which day(s) the report should get generated";
			return;
		}

		var parms: JobScheduleInsertRequest = {
			JobID: this.JobID,
			RunTime: fDate,
			RunMon: this.RunMon,
			RunTue: this.RunTue,
			RunWed: this.RunWed,
			RunThu: this.RunThu,
			RunFri: this.RunFri,
			RunSat: this.RunSat,
			RunSun: this.RunSun,
		};

		this.Processing = true;

		var result = this.dataService.JobScheduleInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "modifyschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schedule was created successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "modifyschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the schedule: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		var fDate = moment(this.RunTime).format("HH:mm:00");

		if (String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Run Time";
			return;
		}

		if (
			this.RunMon == false &&
			this.RunTue == false &&
			this.RunWed == false &&
			this.RunThu == false &&
			this.RunFri == false &&
			this.RunSat == false &&
			this.RunSun == false
		) {
			this.errorMessage = "Select which day(s) the report should get generated";
			return;
		}

		var parms: JobScheduleUpdateRequest = {
			JobScheduleID: this.JobScheduleID,
			Active: this.Active,
			RunTime: fDate,
			RunMon: this.RunMon,
			RunTue: this.RunTue,
			RunWed: this.RunWed,
			RunThu: this.RunThu,
			RunFri: this.RunFri,
			RunSat: this.RunSat,
			RunSun: this.RunSun,
		};

		this.Processing = true;

		var result = this.dataService.JobScheduleUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "modifyschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Schedule was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "modifyschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the schedule: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	///////////////////////////////////////////////////////////
}
